import moment from 'moment';
import { ReactNode } from 'react';
import { IncentivizeRewardsDto } from '../types/spool-local';
import InfoPopUp from '../../components/InfoPopUp';
import { formatPercentages, formatUSD } from '../../helpers/formats';
import { formatUnits } from '@ethersproject/units';
import { TimeConversions } from '../../config/constants';

type Props = {
    incentivizedRewards: IncentivizeRewardsDto[];
    icon?: ReactNode;
};

type RewardProps = {
    reward: IncentivizeRewardsDto;
};

const IncentivizeReward: React.FC<Props> = ({ incentivizedRewards, icon }) => {
    return (
        <InfoPopUp className='incentivized' trigger={icon}>
            <div>
                <strong>
                    This Spool is {incentivizedRewards?.length ? '' : 'not '}
                    incentivized
                </strong>
            </div>
            {incentivizedRewards?.length ? (
                <>
                    <div className='mt'>Incentive Details:</div>
                    {incentivizedRewards
                        .filter(({ isRemoved }) => !isRemoved)
                        .map((reward) => (
                            <Reward key={reward.id} reward={reward} />
                        ))}
                </>
            ) : null}
        </InfoPopUp>
    );
};

export default IncentivizeReward;

const Reward: React.FC<RewardProps> = ({ reward }) => {
    const {
        id,
        symbol,
        decimals,
        apy,
        emissionStartDate,
        totalAmount,
        totalEmissionDays,
        emissionEndDate,
        rewardRate,
    } = reward;

    const remainingDuration = Math.max(
        moment.unix(+emissionEndDate).diff(moment(), 'minutes'),
        0
    );

    const totalDuration = moment
        .unix(+emissionEndDate)
        .diff(moment.unix(+emissionStartDate), 'minutes');

    return (
        <div key={id} className={`mt`}>
            <strong>{symbol}</strong>
            <div>
                APY: <strong>{formatPercentages(parseFloat(apy) * 100 || 0)}%</strong>
            </div>
            <div>
                {symbol}/DAY:{' '}
                <strong>
                    {formatUSD(
                        +(rewardRate ? formatUnits(rewardRate, 18 + decimals) : 0) *
                            TimeConversions.SECONDS_PER_DAY || 0
                    )}
                </strong>
            </div>
            <div>
                Days Remaining:{' '}
                <strong>
                    {formatPercentages(
                        remainingDuration / TimeConversions.MINUTES_PER_DAY
                    )}{' '}
                    ({formatPercentages((remainingDuration / totalDuration) * 100 || 0)}
                    %)
                </strong>
            </div>
            <div>
                {symbol} Initial Terms:{' '}
                <strong className='block'>
                    {formatUSD(totalAmount || 0)} {symbol}{' '}
                </strong>
                Distributed to TVR over <strong>{totalEmissionDays}</strong>
            </div>
        </div>
    );
};
